import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { pure } from 'recompose';

import AuctionGroupContainer from './AuctionGroupContainer';
import AuctionGroupColumns from './AuctionGroupColumns';
import EmptyAuctionGroup from './EmptyAuctionGroup';

/**
 * (dyouberg) Ok so this is the entry point for any standard Live or Timed Sale
 * on the Calendar Page.  For each AuctionGroup - we can break this down into a
 * container which represents the blue header along the top.
 *
 * Each group then also contains a ReactTable within it - the ReactTable is comprised
 * of columns, which is refactored into the AuctionGroupColumns.js class.
 *
 * The columns themselves are simple EXCEPT for the dropdown actions, which have a
 * mind of their own.  They are refactored into AuctionGroupActions.js
 */
const AuctionGroup = ({
  handleCatalogsExceeded,
  handleDeleteSession,
  house,
  group,
  type,
  disableAddSaleAndSessionButton,
}) => {
  const { houseID, paymentProcessingEnabled, paymentProcessingRequired } = house;
  const { catalogs, groupID, live, orphanTerm } = group;

  if (catalogs.length === 0) {
    // For newly created sales, we have no catalogs yet - so return a stubbed out table
    if (type === 'current') {
      return <EmptyAuctionGroup house={house} group={group} type={type} />;
    }
    // This case is needed because empty catalogs were rendering on the past view
    return <div />;
  }

  // COR-1163 - only disable 'Add session' if the following is true.
  const dynamicPricingEnabled = Boolean(house, 'houseInfo.dynamicPricingEnabled');
  const disableAddSessionButton = orphanTerm && dynamicPricingEnabled
  && !(paymentProcessingRequired === false && paymentProcessingEnabled === false);

  return (
    <div className="mb-4">
      <AuctionGroupContainer
        group={group}
        handleCatalogsExceeded={(groupName) => handleCatalogsExceeded(groupName)}
        house={house}
        type={type}
        disableAddSaleAndSessionButton={disableAddSaleAndSessionButton}
        disableAddSessionButton={disableAddSessionButton}
      />
      <ReactTable
        minRows={1}
        data={catalogs}
        defaultPageSize={500}
        columns={AuctionGroupColumns(groupID, handleDeleteSession, houseID, live, type)}
        showPagination={false}
        style={{ width: '100%' }}
        className="-highlight"
        defaultSorted={[{ id: 'time', asc: true }]}
      />
    </div>
  );
};

export default pure(AuctionGroup);
